import { Component } from 'preact'
/* eslint-disable import/no-internal-modules */
import Header from '@insided/deprecated-control/header'
import axios from 'axios'
import AlertBox, { MessageTypes } from '@insided/deprecated-preact-components/design-system-components/message'
import { CustomPage } from '@insided/control/modules/CustomPages/CustomPagesList'
import GeneralPanel from '@insided/control/modules/CustomPages/GeneralPanel'
import SEOPanel from '@insided/control/modules/CustomPages/SEOPanel'

interface State {
    title: string
    slug: string
    seoName: string
    seoDescription: string
    alertMessage: string
    alertMessageType?: null | MessageTypes
    requiredFieldsError: {
        title: boolean
        slug: boolean
    }
}

interface Props {
    customPage: CustomPage
}

export class CustomPageEdit extends Component<Props, State> {
    constructor (props: Props) {
        super(props)

        const { title, slug, seo_fields: seoFields } = props.customPage

        this.state = {
            title: title,
            slug: slug,
            seoName: seoFields.name,
            seoDescription: seoFields.description,
            alertMessage: '',
            alertMessageType: null,
            requiredFieldsError: {
                title: false,
                slug: false
            }
        }

        this.editCustomPage = this.editCustomPage.bind(this)
    }

    async editCustomPage() {
        const { title, slug, seoName, seoDescription } = this.state

        if (!title || !slug) {
            return this.setState({
                 requiredFieldsError: {
                    title: !title,
                    slug: !slug
                }
            })
        }

        try {
            const { id } = this.props.customPage

            const requestBody = {
                title,
                slug: slug.replace(/^\//g, ''),
                seo_fields: {
                    name: seoName,
                    description: seoDescription
                }
            }

            const response = await axios.put(`/platform/custom-pages/${id}/edit`, requestBody, {
                validateStatus: (state: number) => {
                    return (state >= 200 && state < 300) || state === 422
                }
            })

            if (response.status === 422) {
                this.setState({
                    alertMessageType: 'error',
                    alertMessage: response.data.error
                })
            } else {
                window.location.assign('/platform/custom-pages?success=true')
            }
        } catch (e) {
            this.setState({
                alertMessageType: 'error',
                alertMessage: 'Something went wrong'
            })
        }
    }

    render () {
        const { title: pageTitle, slug, seo_fields: seoFields } = this.props.customPage
        const { name: seoName, description: seoDescription } = seoFields

        const { alertMessageType, alertMessage, requiredFieldsError } = this.state
        return (
          <div className='custom-pages-edit-page'>
            {alertMessageType && (
              <AlertBox isControl variant={alertMessageType} onDismiss={() => this.setState({ alertMessageType: null })} timer={3000}>
                {alertMessage}
              </AlertBox>
              )}
            <Header
              title={`Edit page '${pageTitle}'`}
              hasBreadcrumb
              breadcrumbText='Back to Custom Pages Main'
              breadcrumbLink='/platform/custom-pages'
              saveCallback={this.editCustomPage}
              cancelCallback={() => {
                  window.location.assign('/platform/custom-pages')
              }}
            />
            <GeneralPanel
              requiredFieldsError={requiredFieldsError}
              title={pageTitle}
              slug={slug}
              isSlugReadOnly
              onTitleChange={(value) => this.setState({ title: value })}
              onSlugChange={(value) => this.setState({ slug: value })}
            />
            <SEOPanel
              name={seoName}
              description={seoDescription}
              onNameChange={(value) => this.setState({ seoName: value })}
              onDescriptionChange={(value) => this.setState({ seoDescription: value })}
            />
          </div>
    )
  }
}

export default CustomPageEdit
